import React, { useEffect, useState, useCallback } from 'react';

import update from 'immutability-helper';
import { Card } from './Card';

export const Container = ({ menuList, setMenuList }) => {
  const [isDragging, setIsDragging] = useState(false);
  const [cards, setCards] = useState(menuList || []);

  useEffect(() => {
    setMenuList(cards);
  }, [cards]);

  useEffect(() => {
    setCards(menuList);
  }, [menuList]);

  const handleArrowUp = (cardId) => {
    let aboveCard = 0;
    for (let i = 0; i < cards.length; i += 1) {
      aboveCard = i - 1;
      if (cards[i]._id === cardId) {
        if (aboveCard >= 0) {
          const newList = [...cards];
          newList[aboveCard] = cards[i];
          newList[i] = cards[aboveCard];
          setCards(newList);
          return;
        }
      }
    }
  };

  const handleArrowDown = (cardId) => {
    let bellowCard = 0;
    for (let i = 0; i < cards.length; i += 1) {
      bellowCard = i + 1;
      if (cards[i]._id === cardId) {
        if (bellowCard <= cards.length - 1) {
          const newList = [...cards];
          newList[bellowCard] = cards[i];
          newList[i] = cards[bellowCard];
          setCards(newList);
          return;
        }
      }
    }
  };

  const handleRemoveFromList = (cardId) => {
    const newList = cards.filter((card) => {
      return card._id !== cardId;
    });
    setCards(newList);
  };

  const moveCard = useCallback(
    (dragIndex, hoverIndex) => {
      const dragCard = cards[dragIndex];
      setCards(
        update(cards, {
          $splice: [
            [dragIndex, 1],
            [hoverIndex, 0, dragCard],
          ],
        })
      );
    },
    [cards]
  );

  const renderCard = (card, index) => {
    return (
      <Card
        key={card._id}
        index={index}
        id={card._id}
        text={card.title}
        moveCard={moveCard}
        generalIsDragging={isDragging}
        setIsDragging={setIsDragging}
        handleArrowUp={handleArrowUp}
        handleArrowDown={handleArrowDown}
        handleRemoveFromList={handleRemoveFromList}
      />
    );
  };

  return (
    <>
      <div
        className="quick-access-cards-container"
        style={
          cards.length > 0
            ? { backgroundColor: 'white' }
            : { backgroundColor: '#e9ebee' }
        }
      >
        {cards.length > 0 ? (
          cards.map((card, i) => renderCard(card, i))
        ) : (
          <div className="quick-access-empty-list">
            <div className="quick-access-card-text">A Lista está Vazia</div>
          </div>
        )}
      </div>
    </>
  );
};
